import styles from '@components/components/Lightbox/Lightbox.module.scss';
import GalleryImage from '@components/components/Slider/GallerySlider/components/GalleryImage/GalleryImage';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import {
  FontAwesomeProIcon,
  Slider,
  SliderControl,
} from '@wienenergiegithub/ui-next';
import { Button as BaseButton } from '@ariakit/react';
import PropTypes from 'prop-types';

const Lightbox = ({
  headingLevel,
  images,
  isExtended,
  lightboxSettings,
  onSwiper,
  open,
  setOpen,
}) => (
  <div
    aria-hidden={!open}
    aria-label="Lightbox"
    aria-modal="true"
    className={classNames(styles.container, {
      [styles.open]: open,
    })}
    role="dialog"
  >
    <BaseButton
      aria-label="Lightbox schließen"
      className={styles.close}
      onClick={() => setOpen(false)}
    >
      <FontAwesomeProIcon
        className={styles.closeIcon}
        icon="times"
        role="presentation"
        size="2x"
        type="regular"
      />
    </BaseButton>
    <div
      className={classNames(styles.lightbox, {
        [styles.lightboxExtended]: isExtended,
      })}
    >
      <Slider
        className={classNames(styles.slider, styles.extended)}
        {...lightboxSettings}
        onSwiper={onSwiper}
      >
        <SliderControl
          className={classNames(styles.arrow, styles.leftArrow, {
            [styles.extended]: isExtended,
          })}
          data-no-slide="true"
          direction="left"
        />

        <SliderControl
          className={classNames(styles.arrow, styles.rightArrow, {
            [styles.extended]: isExtended,
          })}
          data-no-slide="true"
          direction="right"
        />
        {images?.map(imageSettings => (
          <Fragment key={imageSettings.id}>
            <GalleryImage
              hasLightBox={false}
              headingLevel={headingLevel}
              isExtended={isExtended}
              {...imageSettings}
            />
          </Fragment>
        ))}
      </Slider>
    </div>
  </div>
);

Lightbox.propTypes = {
  headingLevel: PropTypes.number,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      caption: PropTypes.string,
      content: PropTypes.string,
      header: PropTypes.string,
      link: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        target: PropTypes.string,
        variant: PropTypes.string,
      }),
      src: PropTypes.string.isRequired,
      srcSet: PropTypes.string,
    }),
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  lightboxSettings: PropTypes.object.isRequired,
};

export default Lightbox;
